module.exports = __webpack_public_path__ + "img/train-green.f86869ee.svg";